import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "items",
    "subtotal",
    "tax",
    "total",
    "template",
    "container",
  ];

  connect() {
    this.calculateSubtotal();
  }

  // Calcule le sous-total de tous les éléments de la commande
  calculateSubtotal() {
    let subtotal = 0;

    // Récupérer tous les contrôleurs d'éléments individuels
    const itemControllers =
      this.application.getControllerForElementAndIdentifier(
        this.itemsTarget,
        "purchase-order-item"
      );

    if (itemControllers) {
      // S'il n'y a qu'un seul seul contrôleur (un seul élément)
      subtotal = itemControllers.getItemTotal();
    } else {
      // S'il y a plusieurs contrôleurs (plusieurs éléments)
      const itemElements = this.itemsTarget.querySelectorAll(
        "[data-controller='purchase-order-item']"
      );

      itemElements.forEach((itemElement) => {
        const itemController =
          this.application.getControllerForElementAndIdentifier(
            itemElement,
            "purchase-order-item"
          );

        if (itemController) {
          subtotal += itemController.getItemTotal();
        }
      });
    }

    // Mise à jour de l'affichage du sous-total
    this.subtotalTarget.textContent = this.formatCurrency(subtotal);

    // Calculer les taxes et le total final
    this.calculateTotal(subtotal);

    const evt = new CustomEvent("purchase_order_item:updateTotalOrder", {
      bubbles: true,
      detail: {},
    });
    this.element.dispatchEvent(evt);
  }

  // Calcule le total avec taxes
  calculateTotal(subtotal) {
    const taxRate = parseFloat(this.taxTarget.dataset.rate) || 0;
    const taxAmount = subtotal * (taxRate / 100);
    const total = subtotal + taxAmount;

    // Mise à jour de l'affichage des taxes et du total
    this.taxTarget.textContent = this.formatCurrency(taxAmount);
    this.totalTarget.textContent = this.formatCurrency(total);
  }

  // Gestion des événements liés aux éléments
  itemChanged(event) {
    this.calculateSubtotal();
  }

  itemRemoved(event) {
    this.calculateSubtotal();
  }

  // Ajoute un nouvel élément à la commande
  addItem(event) {
    event.preventDefault();

    // Cloner le template
    const template = this.templateTarget.innerHTML;
    const newRow = document.createElement("tr");
    newRow.innerHTML = template;
    newRow.dataset.controller = "purchase-order-item";

    // Générer un ID unique pour le nouvel élément
    const uniqueId = Date.now().toString();
    newRow.dataset.id = uniqueId;

    // Ajouter le nouvel élément au conteneur
    this.containerTarget.appendChild(newRow);

    // Recalculer le sous-total
    this.calculateSubtotal();
  }

  // Formater un montant en devise
  formatCurrency(amount) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "XAF",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
}
